import { produce } from 'immer';
import { buildStagingDomainUrl } from 'ContentEditorUI/lib/preview/utils';
import { CONTENT_SAVE_REQUEST_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import { MARK_STAGED_PAGE_SETTINGS_SEEDED, SET_STAGED_PAGE_DATA
// @ts-ignore not yet migrated
} from 'page-editor-ui/redux/actions/actionTypes';
const initialState = {
  sandboxDomainName: null,
  liveDomainName: null,
  status: null,
  previewUrl: null,
  seeded: false
};
const stagedPageReducer = (state = initialState, {
  type,
  payload
}) => produce(state, draft => {
  switch (type) {
    case SET_STAGED_PAGE_DATA:
      draft.sandboxDomainName = payload.sandboxDomainName;
      draft.liveDomainName = payload.liveDomainName;
      draft.status = payload.status;
      draft.previewUrl = payload.previewUrl;
      break;
    case CONTENT_SAVE_REQUEST_SUCCEEDED:
      {
        var _payload$response;
        const stagedPage = payload === null || payload === void 0 || (_payload$response = payload.response) === null || _payload$response === void 0 ? void 0 : _payload$response.stagedPage;
        if (stagedPage) {
          draft.previewUrl = stagedPage.previewUrl || null;
          draft.status = stagedPage.status || null;
          if (stagedPage.domainName) {
            draft.liveDomainName = stagedPage.domainName;
            draft.sandboxDomainName = new URL(buildStagingDomainUrl(stagedPage.domainName, '')).hostname;
          }
        }
        break;
      }
    case MARK_STAGED_PAGE_SETTINGS_SEEDED:
      draft.seeded = true;
      break;
    default:
      break;
  }
});
export default stagedPageReducer;